const initialState = {
    copyrightyear: ''
  };
  
  const copyrightReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_COPYRIGHT_YEAR':
            return { ...state, copyrightyear: action.payload };
        default:
            return state;
    }
  };
  
  export default copyrightReducer;
  